var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { observable, computed, action, reaction, runInAction, toJS } from 'mobx';
import { isArray } from "lodash-es";
import http, { Q } from '@http';
import { SessionKey } from '@common/enums/base';
var unSet = -1;
var StepStore = /** @class */ (function () {
    function StepStore(rootStore) {
        var _this = this;
        this.procareProblemCodeList = [];
        this.totalStep = 4;
        this.toStep = function (step) {
            if (_this.submittingCreate) {
                return;
            }
            _this.additionalDetail = '';
            if (step === 1) {
                _this.setServiceCategory(unSet);
                _this.setServiceType(unSet);
                _this.setServiceCode(unSet);
            }
            if (step === 2) {
                _this.setServiceType(unSet);
                _this.setServiceCode(unSet);
            }
            if (step === 3) {
                _this.setServiceCode(unSet);
            }
        };
        this.serviceCategory = unSet;
        this.serviceType = unSet;
        this.allServiceTypes = [];
        this.getServiceType = function () { return __awaiter(_this, void 0, void 0, function () {
            var allServiceTypes;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.serviceCategory === unSet) {
                            return [2 /*return*/];
                        }
                        this.allServiceTypes.length = 0;
                        return [4 /*yield*/, this.api.getServiceTypeByCategory(this.serviceCategory)];
                    case 1:
                        allServiceTypes = _a.sent();
                        runInAction(function () {
                            if (isArray(allServiceTypes)) {
                                _this.allServiceTypes = allServiceTypes;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        this.serviceCode = unSet;
        this.allServiceCodes = [];
        this.getServiceCode = function () { return __awaiter(_this, void 0, void 0, function () {
            var allServiceCodes;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.serviceCategory === unSet || this.serviceType === unSet) {
                            return [2 /*return*/];
                        }
                        this.allServiceCodes.length = 0;
                        return [4 /*yield*/, this.api.getServiceCode(this.serviceCategory, this.serviceType)];
                    case 1:
                        allServiceCodes = _a.sent();
                        runInAction(function () {
                            if (isArray(allServiceCodes)) {
                                _this.allServiceCodes = allServiceCodes;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        this.directSetAllServiceInfo = function (info) {
            var ServiceCategoryId = info.ServiceCategoryId, ServiceTypeId = info.ServiceTypeId, ServiceCodeId = info.ServiceCodeId;
            _this.serviceCategory = ServiceCategoryId;
            _this.serviceType = ServiceTypeId;
            _this.serviceCode = ServiceCodeId;
            if (_this.rootStore.allCategoryList.length === 0) {
                _this.rootStore.getAllServiceCategory();
            }
            _this.getServiceType();
            _this.getServiceCode();
            _this.rootStore.serviceSearchText = '';
            _this.rootStore.showAllCategory = false;
        };
        this.setServiceCategory = function (serviceCategory) {
            _this.serviceCategory = serviceCategory;
            _this.getServiceType();
        };
        this.setServiceType = function (serviceType) {
            _this.serviceType = serviceType;
            _this.getServiceCode();
        };
        this.setServiceCode = function (serviceCode) {
            _this.serviceCode = serviceCode;
        };
        this.additionalDetail = '';
        this.setAdditionalDetail = function (additionalDetail) {
            _this.additionalDetail = additionalDetail;
        };
        this.attachments = [];
        this.onAddAttachment = function (attachment) {
            _this.attachments.push(attachment);
        };
        this.onRemoveAttachment = function (attachment) {
            _this.attachments = _this.attachments.filter(function (item) { return item !== attachment; });
        };
        this.submitSuccess = false;
        this.onLeave = function () {
            _this.toStep(1);
            _this.submitSuccess = false;
            _this.attachments.length = 0;
            _this.submittingCreate = false;
            _this.additionalDetail = '';
        };
        this.submittingCreate = false;
        this.isCanScheduleSubTask = function () { return __awaiter(_this, void 0, void 0, function () {
            var promise;
            var _this = this;
            return __generator(this, function (_a) {
                this.submittingCreate = true;
                promise = this.api.isCanScheduleSubTask({
                    serviceCodeId: this.serviceCode,
                    procareId: this.rootStore.procareDetail.Id
                });
                promise.then(function (data) {
                    runInAction(function () {
                        _this.isCanScheduleSubTaskResult = data;
                    });
                }).finally(function () {
                    runInAction(function () {
                        _this.submittingCreate = false;
                    });
                });
                return [2 /*return*/, promise];
            });
        }); };
        this.saveSession = function () {
            sessionStorage.setItem(SessionKey.Attachments, JSON.stringify(toJS(_this.attachments)));
            sessionStorage.setItem(SessionKey.ServiceIssue, _this.additionalDetail || "");
        };
        this.submit = function () { return __awaiter(_this, void 0, void 0, function () {
            var params;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submittingCreate = true;
                        params = {
                            serviceCodeId: this.serviceCode,
                            additionalDetail: this.additionalDetail,
                            attachments: this.attachments
                        };
                        return [4 /*yield*/, this.api.createSubTask(params)];
                    case 1:
                        _a.sent();
                        runInAction(function () {
                            _this.submitSuccess = true;
                            _this.submittingCreate = false;
                            _this.additionalDetail = '';
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        this.api = {
            getServiceTypeByCategory: function (serviceCategory) {
                return Q(http.post("/RSP/NewRequest/" + serviceCategory + "/allServiceType"));
            },
            getServiceCode: function (serviceCategory, serviceType) {
                return Q(http.post("/RSP/NewRequest/" + serviceCategory + "/" + serviceType + "/allServiceCode"));
            },
            getProcareProblemCodeList: function () {
                return Q(http.post("/RSP/ProCare/GetProcareProblemCodeList"));
            },
            createSubTask: function (params) {
                return Q(http.post("/RSP/ProCare/CreateSubTask", params));
            },
            isCanScheduleSubTask: function (params) {
                return Q(http.post("/RSP/ProCare/IsCanScheduleSubTask", params));
            }
        };
        this.initReactions();
        this.rootStore = rootStore;
    }
    StepStore.prototype.initReactions = function () {
        var _this = this;
        var getProcareProblemCodeListReactionFn = function () { return (_this.serviceType); };
        var callback = function (serviceType, reaction) { return __awaiter(_this, void 0, void 0, function () {
            var procareProblemCodeList_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(serviceType !== unSet)) return [3 /*break*/, 2];
                        reaction.dispose();
                        return [4 /*yield*/, this.api.getProcareProblemCodeList()];
                    case 1:
                        procareProblemCodeList_1 = _a.sent();
                        runInAction(function () {
                            _this.procareProblemCodeList = procareProblemCodeList_1;
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        reaction(getProcareProblemCodeListReactionFn, callback);
    };
    Object.defineProperty(StepStore.prototype, "canbeProcare", {
        get: function () {
            var _this = this;
            if (this.procareProblemCodeList.length === 0 || this.serviceCode === unSet) {
                return true;
            }
            var canbeProcare = this.procareProblemCodeList.some(function (code) { return code === _this.serviceCode; });
            return canbeProcare;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StepStore.prototype, "currentStep", {
        get: function () {
            if (this.serviceCategory === unSet) {
                return 1;
            }
            if (this.serviceType === unSet) {
                return 2;
            }
            if (this.serviceCode === unSet) {
                return 3;
            }
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StepStore.prototype, "serviceCategoryName", {
        get: function () {
            var _this = this;
            var item = this.rootStore.allCategoryList.find(function (item) { return item.Id === _this.serviceCategory; });
            return item ? item.Name : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StepStore.prototype, "serviceTypeName", {
        get: function () {
            var _this = this;
            var item = this.allServiceTypes.find(function (item) { return item.Id === _this.serviceType; });
            return item ? item.Name : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StepStore.prototype, "serviceCodeName", {
        get: function () {
            var _this = this;
            var item = this.allServiceCodes.find(function (item) { return item.Id === _this.serviceCode; });
            return item ? item.Name : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StepStore.prototype, "canSubmit", {
        get: function () {
            var result = this.additionalDetail.length > 0 && this.procareProblemCodeList.length > 0 && this.canbeProcare;
            return result;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        observable
    ], StepStore.prototype, "procareProblemCodeList", void 0);
    __decorate([
        computed
    ], StepStore.prototype, "canbeProcare", null);
    __decorate([
        computed
    ], StepStore.prototype, "currentStep", null);
    __decorate([
        action
    ], StepStore.prototype, "toStep", void 0);
    __decorate([
        observable
    ], StepStore.prototype, "serviceCategory", void 0);
    __decorate([
        computed
    ], StepStore.prototype, "serviceCategoryName", null);
    __decorate([
        observable
    ], StepStore.prototype, "serviceType", void 0);
    __decorate([
        computed
    ], StepStore.prototype, "serviceTypeName", null);
    __decorate([
        observable
    ], StepStore.prototype, "allServiceTypes", void 0);
    __decorate([
        action
    ], StepStore.prototype, "getServiceType", void 0);
    __decorate([
        observable
    ], StepStore.prototype, "serviceCode", void 0);
    __decorate([
        computed
    ], StepStore.prototype, "serviceCodeName", null);
    __decorate([
        observable
    ], StepStore.prototype, "allServiceCodes", void 0);
    __decorate([
        action
    ], StepStore.prototype, "getServiceCode", void 0);
    __decorate([
        action
    ], StepStore.prototype, "directSetAllServiceInfo", void 0);
    __decorate([
        action
    ], StepStore.prototype, "setServiceCategory", void 0);
    __decorate([
        action
    ], StepStore.prototype, "setServiceType", void 0);
    __decorate([
        action
    ], StepStore.prototype, "setServiceCode", void 0);
    __decorate([
        observable
    ], StepStore.prototype, "additionalDetail", void 0);
    __decorate([
        action
    ], StepStore.prototype, "setAdditionalDetail", void 0);
    __decorate([
        observable
    ], StepStore.prototype, "attachments", void 0);
    __decorate([
        action
    ], StepStore.prototype, "onAddAttachment", void 0);
    __decorate([
        action
    ], StepStore.prototype, "onRemoveAttachment", void 0);
    __decorate([
        observable
    ], StepStore.prototype, "submitSuccess", void 0);
    __decorate([
        action
    ], StepStore.prototype, "onLeave", void 0);
    __decorate([
        computed
    ], StepStore.prototype, "canSubmit", null);
    __decorate([
        observable
    ], StepStore.prototype, "submittingCreate", void 0);
    __decorate([
        action
    ], StepStore.prototype, "isCanScheduleSubTask", void 0);
    __decorate([
        action
    ], StepStore.prototype, "submit", void 0);
    return StepStore;
}());
export default StepStore;
